import React from "react";
import Hero from "../components/Hero";

const Index = () => {
  return (
    <main className="min-h-screen">
      <Hero />
    </main>
  );
};

export default Index;